import { createApp } from './app.js';
import { loadConfig } from './core/config.js';
import { checkDatabase, closeDb, getDb } from './core/db.js';
import { JobRunner } from './core/jobs.js';
import { createLogger } from './core/logger.js';
import { registerAutomationJobs } from './modules/automation/recurring.service.js';
import { pushPendingNotifications } from './modules/messaging/push.service.js';
import { registerEfrisJobs } from './modules/efris/efris.service.js';
import { registerCrmJobs } from './modules/crm/crm.service.js';
import { registerReminderJobs, runSalesSweeps } from './modules/sales/reminders.service.js';
import { registerMessagingJobs } from './modules/messaging/messaging.service.js';

const config = loadConfig();
const logger = createLogger(config);
const db = getDb();

registerMessagingJobs();
registerReminderJobs();
registerCrmJobs();
registerAutomationJobs();
registerEfrisJobs();
const app = createApp({ config, logger, db, checkDb: checkDatabase });

const runner = new JobRunner({ db, config, logger }, 5000, () =>
  runSalesSweeps(db, new Date(), config),
);
runner.start();
// Relay unread in-app notifications to subscribed phones (a no-op unless VAPID keys are set).
setInterval(
  () =>
    void pushPendingNotifications(db, config).catch((e) =>
      logger.warn({ err: e }, 'push relay failed'),
    ),
  20_000,
).unref();

const server = app.listen(config.PORT, () => {
  logger.info(`API listening on http://localhost:${config.PORT}/api/v1`);
});

async function shutdown(signal: string) {
  logger.info(`${signal} received, shutting down`);
  runner.stop();
  server.close(async () => {
    await closeDb();
    process.exit(0);
  });
}
process.on('SIGINT', () => void shutdown('SIGINT'));
process.on('SIGTERM', () => void shutdown('SIGTERM'));
